export const EMAIL_VERIFICATION_ROUTE = "/user/profile/verify/:id/:hash";

const EMAIL_VERIFICATION_PATH_PATTERN =
  /^\/user\/profile\/verify\/[^/]+\/[^/]+\/?$/;

export const isEmailVerificationPath = (pathname: string): boolean =>
  EMAIL_VERIFICATION_PATH_PATTERN.test(pathname);
